document.querySelectorAll('.gls-header').forEach((header) => {
  const toggle = () => {
    if (window.scrollY > 80) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  toggle();
  window.addEventListener('scroll', toggle, { passive: true });

  const menuButton = header.querySelector('.gls-menu-toggle');
  const drawer = header.querySelector('.gls-mobile-drawer');
  if (!menuButton || !drawer) return;

  const closeMenu = () => {
    header.classList.remove('is-menu-open');
    menuButton.setAttribute('aria-expanded', 'false');
  };

  const openMenu = () => {
    header.classList.add('is-menu-open');
    menuButton.setAttribute('aria-expanded', 'true');
  };

  menuButton.addEventListener('click', () => {
    if (header.classList.contains('is-menu-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  drawer.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });
});
